export default __webpack_public_path__ + "static/media/thinkingdiversity.ececd478.jpeg";